
import Http from "../helpers/Http";

class MembershipServie {
  
  async findProperties(data) {
    return await Http.post("/getNearby", data);
  }
  
  async getResumeMemberships(data) {
    // return await Http.post("/franchises/resume", data);
    return await Http.post("/franchise/customers/resume", data);
  }

   getCustomerDetailMember(data) {
    return  Http.post("/franchise/customers/detail", data);
  }

  getCasbackFranchise(){
    return Http.get("/cashback/franchise")
  }

  getCashbackDetail(data){
    return Http.post("/cashback/franchise/detail", data)
  }

  getCashbackMemberDetail(data){
    return Http.post("/cashback/franchise/member/detail", data)
  }

  getFranchisesAd(){
    return Http.get("/admin/franchises")
                       
  }

  getFranchiseDetailAd(data){
    return Http.post("/admin/franchises/detail", data)   
  }
  
  getCashbackDetailAd(data){
    return Http.post("/admin/cashback/detail", data)   
  }

  getCashbackMemberDetailAd(data){
    return Http.post("/admin/cashback/franchise/member/detail", data)   
  }
  getMembersDetailAd(data){
    return Http.post("/admin/franchises/members/detail", data)   
  }

  getCities() {
    return Http.get("/cities");
  }
  
  getRates() {
    return Http.get("/cashback/rates");
  }

  addCashbackRates(data) {
    return Http.post("/cashback/rates", data);
  }

  updateCashbackRates(data) {
    return Http.update("/cashback/rates", data);
  }

  cashbackPay(data){
    return Http.postMultipart("/admin/cashback/pay", data);
  }
  
}

export default new MembershipServie();